var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4863 8.86229L9.44141 0.823226C9.38348 0.765187 9.31468 0.719142 9.23894 0.687725C9.16319 0.656308 9.082 0.640137 9 0.640137C8.918 0.640137 8.83681 0.656308 8.76106 0.687725C8.68532 0.719142 8.61652 0.765187 8.55859 0.823226L0.513672 8.86229C0.279297 9.09667 0.146484 9.41502 0.146484 9.74706C0.146484 10.4365 0.707031 10.9971 1.39648 10.9971H2.24414V16.7334C2.24414 17.0791 2.52344 17.3584 2.86914 17.3584H7.75V12.9834H9.9375V17.3584H15.1309C15.4766 17.3584 15.7559 17.0791 15.7559 16.7334V10.9971H16.6035C16.9355 10.9971 17.2539 10.8662 17.4883 10.6299C17.9746 10.1416 17.9746 9.35057 17.4863 8.86229Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f69c35fc3a5e74f44c40b488eb551ffc.svg";
export { ForwardRef as ReactComponent };